import { render, staticRenderFns } from "./AvailableOtherLaboursMain.vue?vue&type=template&id=d44d3e8c"
import script from "./AvailableOtherLaboursMain.vue?vue&type=script&lang=js"
export * from "./AvailableOtherLaboursMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d44d3e8c')) {
      api.createRecord('d44d3e8c', component.options)
    } else {
      api.reload('d44d3e8c', component.options)
    }
    module.hot.accept("./AvailableOtherLaboursMain.vue?vue&type=template&id=d44d3e8c", function () {
      api.rerender('d44d3e8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AvailableOtherLaboursMain.vue"
export default component.exports